import { SVGProps } from 'react';

export default function Crescent(props: Partial<SVGProps<any>>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 24 26" fill="none" preserveAspectRatio='none' {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M23.7795 20.3279C24.3365 19.5149 23.315 18.6093 22.3809 18.9234C21.2937 19.289 20.1295 19.4871 18.9191 19.4871C12.9239 19.4871 8.06389 14.6271 8.06389 8.63192C8.06389 6.25572 8.82738 4.05785 10.1224 2.27023C10.6998 1.47325 10.1385 0.230392 9.19768 0.519249C3.87188 2.15446 0 7.11195 0 12.9738C0 20.168 5.83204 26 13.0262 26C17.4918 26 21.4326 23.753 23.7795 20.3279Z" fill='#775B73' />
    </svg>
  )
}